/**
 * Central URLs for the Instanodes web properties.
 *
 * All URLs are driven by environment variables so the same Docker image can be
 * deployed to any environment (local dev, staging, production) without a
 * rebuild. Set the relevant NEXT_PUBLIC_* vars when `next build` runs or
 * inject them at runtime via env.sh / the stage .env file.
 *
 * `SITE_URL`  — canonical website origin   (NEXT_PUBLIC_SITE_URL)
 * `APP_URL`   — dashboard / app origin     (NEXT_PUBLIC_APP_URL)
 */

/** Canonical website origin — e.g. https://instanodes.io */
export const SITE_URL = (
  process.env.NEXT_PUBLIC_SITE_URL ?? "https://instanodes.io"
).replace(/\/$/, "");

/** Dashboard / app origin */
export const APP_URL = (
  process.env.NEXT_PUBLIC_APP_URL ?? "https://app.instanodes.io"
).replace(/\/$/, "");

/** Login / sign-up entry point. */
export const APP_LOGIN_URL = `${APP_URL}/login`;

/** One-click node deploy flow — target of the primary "Deploy" CTA. */
export const APP_DEPLOY_URL = `${APP_URL}/app/one-click`;

/**
 * Social / community profile URLs.
 *
 * Overridable per environment via the matching `NEXT_PUBLIC_SOCIAL_*` env var;
 * the defaults are the production Instanodes profiles. Like `APP_URL`, these are
 * inlined at build time in Client Components, so set the env vars at build for
 * any non-default environment.
 */
export const SOCIAL_LINKS = {
  twitter: process.env.NEXT_PUBLIC_SOCIAL_TWITTER_URL ?? "https://x.com/instanodes",
  linkedin:
    process.env.NEXT_PUBLIC_SOCIAL_LINKEDIN_URL ??
    "https://linkedin.com/company/instanodes",
  github:
    process.env.NEXT_PUBLIC_SOCIAL_GITHUB_URL ??
    "https://github.com/Instanodes-Offical",
  telegram:
    process.env.NEXT_PUBLIC_SOCIAL_TELEGRAM_URL ?? "https://t.me/instanodes_official",
  medium: process.env.NEXT_PUBLIC_SOCIAL_MEDIUM_URL ?? "https://medium.com/@instanodes3",
  /** wa.me deep link — digits only, country code included, no `+` or spaces. */
  whatsapp: process.env.NEXT_PUBLIC_SOCIAL_WHATSAPP_URL ?? "https://wa.me/9041280208",
} as const;
